import captionService from 'CaptionService';

export const choose = {
	cancel: () => captionService.getString('00f3d958-a6dc-4ec0-9ee3-e3049d53a27e', 'Cancel'),
	select: () => captionService.getString('b4ce975a-9afd-45c9-954d-ccd68eb1d79b', 'Select'),
};
